import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setGuidId, setRemark, setCycleDate, setSystemSourcePDF } from '../../PersonalAreaInvoicesSlice';
import { getAllInvoicesAsync, getFullMainAsync } from '../../PersonalAreaInvoicesAsyncThunk';

import SwiperCore from 'swiper';
import { Navigation, Pagination, Scrollbar  } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation, Pagination]);

function Graph(props) {
  const { invoicesInfo, history } = props;
  const monthView = history?.filter(item => item.isViewPdf !== true).reverse();

  const clickColumnGraph = (i, monthDetails) => {
    if(monthDetails.guidId && i < 6){
      const invoicesDisplay = props.invoicesInfo?.filter(item => item.isViewPdf !== true).reverse();
      const selectedInvoiceMonth = invoicesDisplay.find(item => item.guidId === monthDetails.guidId);
      if (selectedInvoiceMonth && selectedInvoiceMonth.guidId && selectedInvoiceMonth.guidId !== "") {
        props.setGuidId(monthDetails.guidId);
        props.setCycleDate(monthDetails.cycleDate);
        props.setSystemSourcePDF(selectedInvoiceMonth.systemSourcePDF);
        props.setRemark(null);
        getData();
      } else {
        props.setCycleDate(monthDetails.cycleDate);
        props.setRemark(<p className='remark-month'>אין לך חשבוניות לחודש {monthDetails.cycleMonthName}</p>);
      }
    }
  };

  async function getData() {
    await props.getAllInvoicesAsync();
    props.getFullMainAsync();
  };

  const shortMonths = (item, i) => {
    if(!item.kwhDetails) return null;
    let shortMonth = '';
    const year = item.periodYear.substring(2);
    const cycleMonthName = item.periodMonthName ;
    const maxKwh = Math.max(...monthView.map(item => item.kwhDetails?.kwh || 0), 1);

    switch (cycleMonthName?.trim()) {
      case 'ינואר':
        shortMonth = 'ינו';
        break;
      case 'פברואר':
        shortMonth = 'פבר';
        break;
      case 'מרץ':
        shortMonth = 'מרץ';
        break;
      case 'אפריל':
        shortMonth = 'אפר';
        break;
      case 'מאי':
        shortMonth = 'מאי';
        break;
      case 'יוני':
        shortMonth = 'יוני';
        break;
      case 'יולי':
        shortMonth = 'יולי';
        break;
      case 'אוגוסט':
        shortMonth = 'אוג';
        break;
      case 'ספטמבר':
        shortMonth = 'ספט';
        break;
      case 'אוקטובר':
        shortMonth = 'אוק';
        break;
      case 'נובמבר':
        shortMonth = 'נוב';
        break;
      case 'דצמבר':
        shortMonth = 'דצמ';
        break;
      default:
        shortMonth = item.cycleMonthName;
    };
    return (
      <button key={i} className='container-info-graph' onClick={() => clickColumnGraph(i,item)}>
        <div className='wrapper-graph-height'>
          <div className='price'>
            {item.kwhDetails?.kwh != "0" && item.kwhDetails?.kwh}
          </div>
          <div
            className={`graph-height ${item.guidId === props.guidId ? 'active-color' : ''}`}
            style={{
              height: `${(item.kwhDetails?.kwh / maxKwh) * 100}%`,
              backgroundColor: item.kwhDetails.kwh < 0 ? '#82e9a5' : 'var(--theme-light,#e2cff7)'
            }}>
          </div>
        </div>
        <div className={`month mobile ${item.guidId === props.guidId ? 'active-month' : ''}`}>{shortMonth + ' ' + year}</div>
        {/* <div className={`month desktop ${item.guidId === props.guidId ? 'active-month' : ''}`}>{shortMonth + ' ' + year}</div> */}
      </button>
    );
  };

  return (
    <div className='wrapper-info-graph'>
      {props.isEnergy ?
            <>
                  <Swiper
                    className='swiper-graph'
                    modules={[Navigation, Scrollbar]}
                    scrollbar={{
                      draggable: true,
                      hide: false,
                    }}
                    watchOverflow={true}
                    slidesPerView={'auto'}
                    enabled={true}
                    resistanceRatio={0}
                    >
                    {monthView?.map((item, i) => {
                      return (
                        <SwiperSlide key={i}>
                          {shortMonths(item , i)}
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
            </>
             :
            monthView?.map((item, i) => shortMonths(item , i))
            }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    indexMonth: state.personalAreaInvoicesPage.indexMonth,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo.history,
    guidId: state.personalAreaInvoicesPage.guidId,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {
  setGuidId,
  getAllInvoicesAsync,
  getFullMainAsync,
  setRemark,
  setCycleDate,
  setSystemSourcePDF
};
export default connect(mapStateToProps, mapDispatchToProps)(Graph);
